import React from 'react';

import LicenseForm from './LicenceForm'

import CircularProgress from '@material-ui/core/CircularProgress';

import { AppManager } from 'top-app-manager';
import 'top-app-manager/dist/index.css';
import './App.css';

import config from './config/app-config.json';
import apps from './config/apps.json';

export const authConfig = {
  ...config,
  ...apps
};



function App() {
  let roles = [];
  let noSession = false;
  let storedRoles = localStorage.getItem('session');
  if (!storedRoles) {
    roles = [];
    noSession = true;
  }

  try {
    storedRoles = JSON.parse(localStorage.getItem('session'));

    if (storedRoles && storedRoles.user && storedRoles.user['cognito:groups']) {
      roles = storedRoles.user['cognito:groups'];
    } else {
      roles = [];
      noSession = true;
    }
  } catch (err) {
    console.log(err);
    roles = [];
  }

  return <>
  <div className="page">
    <AppManager config={authConfig} />
    <div
      style={{
        margin: `0 auto`,
        backgroundColor: "white",
        borderRadius: 7
      }}
    >
      {
        roles.includes('licensing_all_access') ? <LicenseForm /> :
          noSession ? <p>You are not authorized to see this page.</p> :
            <CircularProgress />
        // <h2>You are not authorized to see this page</h2>
      }
    </div>
  </div>
    <footer className="footer">
      © {new Date().getFullYear()}, SmartBrands
    </footer>
 </> ;
}

export default App;
